import React from 'react';

const customEvent = () => (
  <div style={{width: "100%", height: "100%", backgroundColor: "#dee7d2", marginLeft:"5%", paddingLeft:"5%"}}>Apartado</div>
);

export default customEvent;